import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AppInfoService } from '../app-info/app-info.service';

@Injectable({
  providedIn: 'root'
})
export class NsLocaleGuard implements CanActivate {
  constructor(private appInfoService: AppInfoService) {}

  canActivate(): boolean {
    return !this.appInfoService.isNSLocaleSelected();
  }
}
